import clsx from "clsx";
import { FaBars, FaTimes } from "react-icons/fa";

const MobileSwitcher = ({ mobileOpen, setMobileOpen }) => {
  return (
    <div className="relative z-50 block xl:hidden">
      <button type="button" aria-label="Toggle mobile menu" onMouseDown={() => setMobileOpen(!mobileOpen)} className={clsx("text-xl p-4", mobileOpen ? "" : "")}>
        <FaTimes className={clsx("", mobileOpen ? "opacity-100" : "opacity-0 hidden")} />
        <FaBars className={clsx("", mobileOpen ? "opacity-0 hidden" : "opacity-100")} />
      </button>
    </div>
  );
};

export default MobileSwitcher;
